import { Post } from "@/src/models/post.model";
import dayjs from "dayjs";
import { useRouter } from "expo-router";
import { CloseCircle } from "iconsax-react-nativejs";
import { Pressable, Text, View } from "react-native";
import { useTheme } from "@/src/styles/theme-provider";
import DropDown, { ContextMenuItem } from "../../ui-kit/drop-down";
import BlocksAvatar from "../../ui-kit/blocks-avatar";

type PostHeaderProps = Readonly<{
  post: Post;
  showClose?: boolean;
  onClose?: () => void;
  menuItems?: ContextMenuItem[];
}>;

const PostHeader = ({
  post,
  showClose,
  onClose,
  menuItems = [],
}: PostHeaderProps) => {
  const { themeVars } = useTheme();
  const router = useRouter();

  return (
    <View className="flex-row justify-between items-center px-4 py-3 border-b border-ash-3">
      <Pressable
        className="flex-row items-center gap-3 hover:opacity-70 flex-1 min-w-0"
        onPress={() => {
          const authorId = post.authorSnapshot?.userId ?? post.CreatedBy;
          if (!authorId) return;
          router.push({
            pathname: "/profile/[id]",
            params: { id: authorId },
          });
        }}
      >
        <BlocksAvatar
          userId={post.authorSnapshot?.userId ?? post.CreatedBy}
          fallbackImageUrl={post.authorSnapshot?.profileImageUrl}
          firstName={post.authorSnapshot?.firstName}
          lastName={post.authorSnapshot?.lastName}
          size={40}
          className="rounded-full"
        />
        <View className="flex-1 min-w-0">
          <Text className="font-medium text-sm text-onyx" numberOfLines={1}>
            {`${post.authorSnapshot?.firstName ?? ""} ${post.authorSnapshot?.lastName ?? ""}`.trim() ||
              "User"}
          </Text>
          <Text className="text-xs text-slate">
            {dayjs(post.CreatedDate).fromNow()}
          </Text>
        </View>
      </Pressable>

      {showClose ? (
        <Pressable
          onPress={onClose}
          className="p-2 rounded-full hover:bg-ash-3/40"
        >
          <CloseCircle size={30} color={themeVars["--color-slate-default"] as string} />
        </Pressable>
      ) : (
        <DropDown
          items={menuItems}
          iconSize={20}
          iconColor={themeVars["--color-slate-default"] as string}
        />
      )}
    </View>
  );
};

export default PostHeader;
